export const compareByAsc = (a, b, key) => {
  if (a[key] < b[key]) return -1;
  if (a[key] > b[key]) return 1;
};

export const compareByDesc = (a, b, key) => {
  if (a[key] < b[key]) return 1;
  if (a[key] > b[key]) return -1;
};
